export default __webpack_public_path__ + "static/john-hill-resume-software-engineer-17c22ab2a20be0a02093db8d94fcc7f4.pdf";